module.exports = __webpack_public_path__ + "static/media/knob2.81e527b6.png";